import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import _ from "lodash";
import { useApollo } from "apollo";

const AVAILABLE_YEARS_QUERY = gql`
  query($indicator: ID!, $typing: Typing!) {
    availableYears(indicator: $indicator, typing: $typing) {
      representation
    }
  }
`;

export function useAvailableYears(indicator, typing) {
  if (!indicator || !typing) {
    return {
      data: []
    };
  }

  const { application } = useApollo();
  const { data } = useQuery(AVAILABLE_YEARS_QUERY, {
    client: application,
    variables: {
     indicator,
     typing 
    }
  });
  
  return {
    data: _.get(data, "availableYears", [])
  };
}



// WEBPACK FOOTER //
// ./src/components/filters/year-selector/data.js